import React, { FC } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import getRouters from '@/components/common/getRouters';
import { routers } from './router.config';
import DocumentTitle from 'react-document-title';
import { getPageTitle } from '@/utils/utils';
import AppConsts from '@/lib/appconst';
import Entry from '@/scenes/Entry';

const Router = () => {
    const {pathname} = useLocation();
    console.log('pathname:',pathname)
    return (
        <DocumentTitle title={getPageTitle(pathname)}>
            <Switch>
                <Route path="/" render={(props: any) => <Entry />} />
            </Switch>
        </DocumentTitle>
    );
};

export default Router;